import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {
  private apiUrl = `${environment.apiUrl}/services`;

  constructor(private http: HttpClient) { }

  getAllServices(): Observable<any> {
    return this.http.get(`${this.apiUrl}/services`);
  }

  updateServiceUtility(serviceName: string, providerName: string, idServicio: string, newPercentage: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/services/${serviceName}/providers/${providerName}/services/${idServicio}`, { newPercentage });
  }

  updateServiceStatus(serviceName: string, providerName: string, idServicio: string, status: boolean): Observable<any> {
    return this.http.put(`${this.apiUrl}/services/status/${serviceName}/providers/${providerName}/services/${idServicio}`, { newStatus: status });
  }
  
}